import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {Offer} from '../../../../../core/models/offer/offer.model';
import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from '@angular/material';
import tippy from 'tippy.js';
import {OfferNumberContext} from '../../../../services/offer-number.service';
import {DialogConfigBase} from '../../../../components/dialogs/dialog-config-base';
import {DialogComponentInterface} from '../../../../components/dialogs/dialog-component.interface';
import {DialogConfigInterface} from '../../../../components/dialogs/dialog-config.interface';
import {OffersPresentationData, OffersPresentationService} from '../../../../../core/services/impl/offers-presentation.service';
import {OfferResourceService} from '../../../../../core/services/impl/offer-resource.service';
import {InsuranceDataSummaryContext} from '../../next-offers-section/insurance-data-summary/insurance-data-summary.component';
import {isNext} from '../../../../../core/utils/utils';

@Component({
  selector: 'app-offers-presentation',
  templateUrl: './offers-presentation.component.html',
  styleUrls: ['./offers-presentation.component.scss']
})
export class OffersPresentationComponent implements OnInit, AfterViewInit, DialogComponentInterface {

  colspanHead: number = 2;
  colspanFooter: number = 1;
  contentScrolled: boolean = false;

  isNext = isNext();
  DataSummaryContext = InsuranceDataSummaryContext;

  private readonly offerNumberContext = OfferNumberContext.OFFER_PRESENTATION;

  static getConfigBuilder(): any {
    return new OffersPresentationConfig();
  }

  get removeIcon(): string {
    return this.isNext ? 'highlight_off' : 'close';
  }

  get downloadOWUButtonLabel(): string {
    return this.isNext ? 'OFFER_SECTION.COMPARE.downloadOWU' : 'OFFER_SECTION.COMPARE.download';
  }

  get downloadOWUButtonIcon(): string {
    return this.isNext ? './assets/images/icons/download-pdf.svg' : './assets/images/download-mobile.png';
  }

  ngOnInit() {
    this.updateContentScrolled = this.updateContentScrolled.bind(this);
    this.handleScroll();
  }

  ngAfterViewInit() {
    tippy('.tooltip', {
      duration: 250,
      arrow: true,
      arrowType: 'round',
    });
    this.offerResourceService.updatePdfLinks();
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: OffersPresentationData,
              public offersPresentationService: OffersPresentationService,
              public offerResourceService: OfferResourceService,
              private dialog: MatDialogRef<OffersPresentationComponent>) {
    this.offersPresentationService.init(data);
  }

  selectOffer(offer: Offer) {
    this.offersPresentationService.selectOffer(offer);
    if (!this.offersPresentationService.isOfferSelectionNotAllowed(offer)) {
      this.dialog.close(offer);
    }
  }

  close() {
    this.dialog.close();
  }

  private updateContentScrolled(): void {
    this.contentScrolled = document.querySelector('.app-offers-dialog').scrollTop > 0;
  }

  private handleScroll(): void {
    const panel = document.querySelector('.app-offers-dialog');
    panel.addEventListener('scroll', this.updateContentScrolled);
  }
}

export class OffersPresentationConfig extends DialogConfigBase implements DialogConfigInterface {

  private config: MatDialogConfig = {
    panelClass: isNext() ? ['app-offers-dialog--next', 'app-offers-dialog'] : 'app-offers-dialog',
    autoFocus: false,
  };

  constructor() {
    super();
  }

  buildConfiguration(data: OffersPresentationData): MatDialogConfig {
    return this.buildConfig(data, this.config);
  }
}
